// src/quiz/gre-mock7/index.js
// GRE Mock 7 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 7" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock7 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 7",
    title: "GRE Verbal Reasoning — Mock 7",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 7",
    title: "GRE Quantitative Reasoning — Mock 7",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 7",
    title: "GRE Analytical — Mock 7",
    prompt:
      "\"Governments should invest more heavily in public transportation than in building new roads, because efficient public transit benefits society more than increased road capacity ever can.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the statement and explain your reasoning for the position you take. In developing and supporting your position, you should consider ways in which the statement might or might not hold true.",
    topicKeywords: [
      "transport", "public", "road", "infrastructure", "govern", "invest",
      "congest", "urban", "commut", "citizen", "environment", "cost",
      "emission", "econom", "rural", "traffic",
    ],
  },
};
